import { Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  selector: 'atom-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFileComponent),
      multi: true,
    }
  ],
})
export class InputFileComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() multiple: boolean = false;
  @Input() accept: string = '*';

  value: File | File[] | null = null;  

  private onChange = (_: any) => {};
  private onTouched = () => {};

  writeValue(value: File | File[] | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInput(event: Event): void {
    const element = event.target as HTMLInputElement;
    const fileList: FileList | null = element.files;

    if (fileList && fileList.length > 0) {
      if (this.multiple) {
        // Convertimos FileList a un Array real para manejarlo fácil
        this.value = Array.from(fileList).filter(f => f.size > 0);
      } else {
        const file = fileList[0];
        this.value = file.size > 0 ? file : null;
      }
    } else {
      this.value = null;
    }

    this.onChange(this.value);
    this.onTouched();
  }

  onBlur(): void {
    this.onTouched();
  }

  get fileName(): string {
    if (!this.value) return '';
    if (Array.isArray(this.value)) {
      return this.value.length > 1 
        ? `${this.value.length} archivos seleccionados` 
        : this.value[0].name;
    }
    return this.value.name;
  }
}
